module.exports = __webpack_public_path__ + "media/shared/desnivel-derecho-icon-4c2a8384.png";